'use strict';

var $ = require('jquery');
var Debouncer = require('../lib/Debouncer.js');
var ViewportTracker = require('../lib/ViewportTracker.js');

function init(target, excludeState) {
	var $target = $(target);
	var activeClass = target + '--scrolled';
	var scrollTop = $target.scrollTop();
	var state = ViewportTracker.getState();

	// If provided scrolledArea not present or view is excluded, exit.
	if ($target.length === 0 || state === excludeState) {
		return;
	}

	function getScrollTop() {
		if (typeof pageYOffset != 'undefined') {
			// most browsers
			return pageYOffset;
		} else {
			// Android devices
			var B = document.body;
			var D = document.documentElement;
			D = (D.clientHeight) ? D : B;
			return D.scrollTop;
		}
	}

	function affectTarget() {
		if (getScrollTop() > 0 && !($target.hasClass(activeClass))) {
			$target.addClass(activeClass);
		}
		else if (getScrollTop() === 0) {
			$target.removeClass(activeClass);
		}
	}

	var scrollDebouncer = new Debouncer(affectTarget);

	// On scroll, activate or deactivate target.
	$(window).on('scroll', scrollDebouncer.run);
}

module.exports = {
	init : init
};
